import { LabTech } from 'schema'
import {
  simpleErrorNotification,
  simpleSuccessNotification,
} from 'hooks/notificationHandler'
import { MutationHookOptions } from '@apollo/client'
import { errorHandler } from 'hooks/errorHandler'

export function useCatchDuplicateKeyError<T>(
  mutation: 'edited' | 'created',
  onCompleted: (response: T) => Pick<LabTech, 'name'>
): MutationHookOptions<T> {
  return {
    onCompleted: (response) => {
      const { name } = onCompleted(response)
      return simpleSuccessNotification(`${name} successfully ${mutation}!`)
    },
    onError: (err) => {
      if (err.message.toLowerCase().includes('cannot insert duplicate key'))
        simpleErrorNotification('Users can only be made a Lab Tech once!')
      else errorHandler(err)
    },
  }
}
